module.exports = __webpack_public_path__ + "static/padded_armor-12345eed13aecd2ac9061598a6f04df6.jpg";